import React, { useEffect, Fragment, useState } from "react";
import { Helmet } from "react-helmet";

import { Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { ForgetPass, GetSeo, UserAttemptToLogin } from "./Components/Services";
import { useDispatch, useSelector } from "react-redux";

const UserLogin = ({ isModal, setShowSignup, setShowLogin, setShowModalLogin, setShowFroget }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { basket, user_type } = useSelector((state) => state);

  const initialState = {
    loading: false,
    data: {
      mobile: location.state ? location.state.mobile : null,
      password: null,
    },
  };

  const [state, setState] = useState(initialState);

  const UserLoginHandler = (mobile, password) => {
    setState({ ...state, loading: true });
    UserAttemptToLogin(mobile, password).then((result) => {
      setState({
        ...state,
        loading: false,
      });
      if (typeof result === "object") {
        localStorage.removeItem("user");
        dispatch({
          local_storage: {
            key: "user",
            value: result,
          },
          type: "SET",
          payload: { user: result },
        });
        dispatch({
          local_storage: {
            key: "user_type",
            value: result.role,
          },
          type: "SET",
          payload: { user_type: result.role },
        });
        // if (
        //   result.role == "manager" &&
        //   result.item &&
        //   result.item[0] &&
        //   result.item.length > 1
        // ) {
        //   navigate("/User/Dashboard");
        // } else {
        // navigate("/User/Dashboard");
        // }

        if (!isModal) {
          navigate("/User/Dashboard");
        }
        else {
          setShowModalLogin(false)
        }
      }
    });
  };
  const ForgetPasswordHandler = (mobile) => {
    setState({ ...state, loading: true });
    ForgetPass(mobile).then((result) => {
      if (result.status == 'error') {
        setState({ ...state, loading: false });
      } else {
        if (!isModal) {
          navigate("/ForgetPassword", {
            state: { mobile: state.data.mobile },
          });
        }
        else {
          setShowFroget(true);
          setShowLogin(false);
        }
      }
    });
  };

  if (user_type) {
    if (!isModal) {
      return <Navigate to={"/User/Dashboard"} />
    }
    else {
      setShowModalLogin(false)
    }
  }
  return (
    <Fragment>
      {!isModal &&
        <Helmet>
          <title>نیکوتن | ورود به سایت</title>
        </Helmet>
      }
      <div className={"main-login d-flex justify-content-center align-items-center " + (!isModal && "py-4 ")
        + (window.screen.width > 575 ? !isModal && "my-5" : "my-0")}>
        <div className="container-fluid px-3 px-md-5">
          <div className="d-flex justify-content-center">
            <div
              className={"rounded-11 login " + (!isModal && "part-padding")}
              style={{
                boxShadow: !isModal && "rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.24) 0px 0px 5px",
                width: !isModal && "450px"
              }}>
              <div className="center">
                <div className="top mb-5 d-flex flex-column align-items-center justify-content-center">
                  <Link to={"/"}>
                    <img
                      className="img"
                      style={{ width: window.screen.width > 575 ? "150px" : "100px" }}
                      src={window.origin + "/WebSide/assets/images/logo.png"}
                      alt="nikotan | نیکوتن"
                    />
                  </Link>
                  <img
                    style={{ width: window.screen.width > 575 ? "100%" : "80%" }}
                    className="mt-1"
                    src={window.origin + "/WebSide/assets/images/sam.png"}
                  />
                </div>
                <div className="form-group login-form-group mx-auto">
                  <div className="inputt-group">
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      شماره موبایل
                    </p>
                    <input
                      style={{ borderRadius: "10px" }}
                      className="form-control mb-3"
                      type="text"
                      disabled={location.state && location.state.mobile}
                      value={location.state && location.state.mobile}
                      onChange={(e) => {
                        setState({
                          ...state,
                          data: { ...state.data, mobile: e.target.value },
                        });
                      }}
                      placeholder="شماره موبایل"
                    />
                    <p className="h6 mb-2" style={{ color: "#404040" }}>
                      کلمه عبور خود را وارد نمایید
                    </p>
                    <input
                      style={{ borderRadius: "10px" }}
                      className="form-control mb-3"
                      type="password"
                      value={state.data.password}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          UserLoginHandler(
                            state.data.mobile,
                            state.data.password
                          );
                        }
                      }}
                      onChange={(e) => {
                        setState({
                          ...state,
                          data: { ...state.data, password: e.target.value },
                        });
                      }}
                      placeholder="کلمه عبور"
                    />
                  </div>
                </div>
                <button
                  onClick={() =>
                    UserLoginHandler(state.data.mobile, state.data.password)
                  }
                  style={{ borderRadius: "10px" }}
                  className={`btn btn-red-v2 w-100 h6 mb-3 text-white ${state.loading ? "disabled" : null} `}>
                  {state.loading ? "در حال پردازش..." : "ورود"}
                </button>
                <p className="text-center mb-2" style={{ color: "#404040" }}>
                  رمز خود را فراموش کرده اید؟
                  <a
                    onClick={() => {
                      ForgetPasswordHandler(state.data.mobile);
                    }}
                    className=" ms-2 fw-bold"
                    style={{
                      color: "#E42A3F",
                      cursor: "pointer",
                    }}>
                    تغییر رمز عبور
                  </a>
                </p>
                <p className="text-center" style={{ color: "#404040" }}>
                  حساب کاربری ندارید؟
                  {!isModal
                    ?
                    <Link
                      to={"/Signup"}
                      className=" ms-2 fw-bold"
                      style={{ color: "#E42A3F" }}>
                      ایجاد حساب کاربری
                    </Link>
                    :
                    <Link
                      onClick={() => {
                        setShowSignup(true)
                        setShowLogin(false)
                      }}
                      className=" ms-2 fw-bold"
                      style={{ color: "#E42A3F" }}>
                      ایجاد حساب کاربری
                    </Link>}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserLogin;
